import { supabase } from './supabaseClient';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * 구독 상태 확인 함수 — BE API를 통해 확인
 * @param {Object} session - 사용자 세션 정보
 * @returns {Object} { loading, hasAccess, subscription, freeTrialInfo }
 */
export const checkSubscriptionStatus = async (session) => {
    const result = {
        loading: true,
        hasAccess: false,
        subscription: null,
        freeTrialInfo: null
    };

    if (!session?.access_token) {
        return { ...result, loading: false };
    }

    try {
        const response = await fetch(`${API_URL}/subscription-status`, {
            headers: { Authorization: `Bearer ${session.access_token}` },
        });

        if (!response.ok) {
            return { ...result, loading: false };
        }

        const data = await response.json();

        if (data.hasActiveSubscription && data.subscriptions) {
            const now = new Date();
            for (const sub of data.subscriptions) {
                if (!sub.isActive) continue;

                if (sub.plan_name === 'FREE_TRIAL') {
                    result.freeTrialInfo = sub;
                } else {
                    result.subscription = sub;
                }
            }
            result.hasAccess = data.hasActiveSubscription;
        }
    } catch (error) {
        console.error('Failed to check subscription status:', error);
    } finally {
        result.loading = false;
    }

    return result;
};
